module.exports = __webpack_public_path__ + "35ef984e3436e9926b3742c71afaca83.svg";